import React, { createContext, useState, useEffect } from 'react';

// Create Language Context
export const LanguageContext = createContext();

// Language Provider Component
const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'pt');

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const setPortuguese = () => {
    setLanguage('pt');
  };
  const setEnglish = () => {
    setLanguage('en');
  };

  return (
    <LanguageContext.Provider value={{ language, setPortuguese, setEnglish }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;